import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import Nav from '../shared/nav/Nav';
import Details from './details/Details';
import MetaData from '../shared/metaData/MetaData';
import getDetailsData from './details/helpers/getDetailsData';
import nameRows from './nameRow';
import BestOdds from '../shared/price/BestOdds';

const HumanPage = ({ data, children, params, userRole, pageName }) => {
    const NameRow = nameRows[params.type];
    const detailsData = getDetailsData(data.recordsByType, params.type);
    const {
        externalLinks: {
            imagesUrl,
            helpCenterUrl,
        },
        profile,
        skybetDiffusionName,
    } = data;

    return (
        <div>
            <MetaData
                type={params.type}
                page={params.tab ? params.tab : 'form'}
                name={profile.styleName}
            />
            <section>
                <NameRow profile={profile} imagesHost={imagesUrl} />
                <Details
                    data={detailsData}
                    type={params.type}
                />
                <BestOdds skybetDiffusionName={skybetDiffusionName} />
            </section>
            <Nav
                params={params}
                helpUrl={helpCenterUrl}
                userRole={userRole}
                pageName={pageName}
            />
            {cloneElement(children, { data, params })}
        </div>
    );
};

HumanPage.propTypes = {
    data: PropTypes.shape({
        externalLinks: PropTypes.shape({
            imagesUrl: PropTypes.string,
            helpCenterUrl: PropTypes.string,
        }).isRequired,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string.isRequired,
    }).isRequired,
    children: PropTypes.node.isRequired,
    userRole: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
};

export default HumanPage;



// WEBPACK FOOTER //
// ./src/js/human/HumanPage.jsx